import { Container } from "@mui/material";
import React from "react";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import SignUpForm from "../components/Forms/SignUpForm";
import "../Style/Theme/index.css";
import ContainerWithLogo from "./ContainerWithLogo";

export default function SignUp() {
  return (
    <>
      <ContainerWithLogo>
        <SignUpForm />
      </ContainerWithLogo>
    </>
  );
}
